
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export const useAdminData = (isAdmin: boolean) => {
  const [recentBookings, setRecentBookings] = useState<any[]>([]);
  const [parkingSpots, setParkingSpots] = useState<any[]>([]);
  const [users, setUsers] = useState<any[]>([]);
  const { toast } = useToast();

  useEffect(() => {
    const fetchData = async () => {
      if (!isAdmin) return;

      try {
        const [
          { data: bookingsData, error: bookingsError },
          { data: spotsData, error: spotsError },
          { data: usersData, error: usersError }
        ] = await Promise.all([
          supabase
            .from('bookings')
            .select(`
              *,
              profiles:user_id (first_name, last_name),
              parking_spot:parking_spots (address, owner_name)
            `)
            .order('created_at', { ascending: false })
            .limit(10),
          
          supabase
            .from('parking_spots')
            .select('*')
            .order('created_at', { ascending: false }),
          
          supabase
            .from('profiles')
            .select(`
              *,
              user_roles!inner (
                role
              )
            `)
            .order('created_at', { ascending: false })
        ]);

        if (bookingsError) throw bookingsError;
        if (spotsError) throw spotsError;
        if (usersError) throw usersError;

        setRecentBookings(bookingsData || []);
        setParkingSpots(spotsData || []);
        setUsers(usersData || []);
      } catch (error) {
        console.error('Error fetching admin data:', error);
        toast({
          title: "Error",
          description: "Failed to load dashboard data",
          variant: "destructive",
        });
      }
    };

    fetchData();
  }, [isAdmin, toast]);

  return { recentBookings, parkingSpots, users };
};
